import React from "react";
import classes from "./TermsOfService.module.css";

function TermsOfService() {
  return (
    <div className={classes.termsDetails}>
      <h4 className={classes.h4}>Terms of Service</h4>
      <div>
        <p>
          <strong>SUPERIOR LOAN SERVICING, LLC</strong> (“Provider”) maintains
          the <strong>SUPERIOR LOAN SERVICING</strong> website and online
          portal, including related features, products, and services
          (collectively, the “Service”). You should read these Terms of Use
          (this “Agreement”) carefully before using the Service. Access to and
          use of the Service is subject to the terms and conditions set forth
          below, and your use of the Service signifies and constitutes your
          acceptance of this Agreement. If you do not agree to this Agreement,
          you should not use the Service. The provider may revise this Agreement
          from time to time. Although Provider may include a notice on the home
          page of the Service that the Agreement has been modified, such notice
          may not remain in place for any extended period of time. Accordingly,
          you should review the Agreement as posted on the Service from time to
          time. Using the Service after any revised Agreement has been posted
          will constitute your acceptance of the revised terms.
        </p>

        <p>
          Your entry into this Agreement shall not affect any written agreements
          between you and Provider, all of which shall remain in full force and
          effect according to their terms. With respect to your use of the
          Service, any written agreement between you and Provider regarding the
          Service shall govern in the event of any inconsistency between this
          Agreement and such written agreement.
        </p>

        <p>
          Please be advised that Superior Loan Servicing is a debt collector,
          and may be attempting to collect a debt. Any information obtained will
          be used in furtherance of that purpose.
        </p>
        <h6>1. Purpose of the Service</h6>
        <p>
          The Service provides a number of different features, products, and
          services to assist private lenders service their loans, including
          information regarding individuals, business assets, personal property,
          insurance policies and loan information. The service is not intended
          to provide legal, tax or financial advice. NEITHER PROVIDER NOR THE
          SERVICE IS INTENDED TO PROVIDE LEGAL, TAX OR FINANCIAL ADVICE.
          PROVIDER IS NOT A FINANCIAL PLANNER, BROKER OR TAX ADVISOR AND DOES
          NOT OFFER PROOF OF OWNERSHIP OR POSSESSION OF RECORDS. The Service is
          intended only to assist you in servicing your loans and is broad in
          scope. Your personal situation is unique, and any information and
          advice obtained through the Service may not be appropriate for your
          situation. Accordingly, before making any final decisions or
          implementing any loan servicing, insurance, or financial strategy, you
          should consider obtaining advice from your lender, accountant or other
          financial advisers who are fully aware of your individual
          circumstances. You acknowledge that Provider disclaims any
          responsibility for or liability related to your use of the Service
          (see “Disclaimer of Warranties” below).
        </p>
        <h6>2. Use of the Service</h6>
        <p>
          Use of the Service may be available through a compatible Internet
          browser or mobile device and may require network connections and
          software. You agree that you are solely responsible for these
          requirements, including any applicable changes, updates and fees as
          well as the terms of your agreement with your mobile device and
          telecommunications provider. Your right to access and use the Service
          is personal to you and is not transferable by you to any other person
          or entity. You are only entitled to access and use the Service for
          lawful purposes. Accurate records enable Provider to provide the
          Service to you. You must provide true, accurate, current and complete
          information about your accounts and you may not misrepresent your
          registration information. In order for the Service to function
          effectively, you must also keep your registration information up to
          date and accurate. If you do not do this, the accuracy and
          effectiveness of the Service to you will be affected. You agree that
          Provider may use your feedback, suggestions, or ideas in any way,
          including in future modifications of the Service, other products or
          services, advertising or marketing materials. You grant Provider a
          perpetual, worldwide, fully-transferable, sub-licensable, irrevocable,
          fully paid-up, royalty-free license to use the feedback you provide to
          Provider in any way. You further agree that you will not: (i) use any
          robot, spider, scraper, deep link or other similar automated data
          gathering or extraction tools, program, algorithm or methodology to
          access, acquire, copy or monitor the Service or any portion of the
          Service, without Provider’s express written consent, which may be
          withheld in Provider’s sole discretion; (ii) use or attempt to use any
          engine, software, tool, agent, or other device or mechanism (including
          without limitation browsers, spiders, robots, avatars or intelligent
          agents) to navigate or search the Service, other than the search
          engines and search agents available through the Service and other than
          generally available third-party web browsers; (iii) post or transmit
          any file which contains viruses, worms, Trojan horses or any other
          contaminating or destructive features, or that otherwise interfere
          with the proper working of Provider or the Service; or (iv) attempt to
          decipher, decompile, disassemble, or reverse-engineer any of the
          software comprising or in any way making up a part of the Service.
        </p>
        <h6>3. Lawful Use; Use by Minors</h6>
        <p>
          Your access to and use of the Service is subject to all applicable
          international, federal, state and local laws and regulations. You
          represent and warrant that you will not use the Service in any manner
          or for any purposes that are unlawful or prohibited by this Agreement.
          The Service is not targeted towards, nor intended for use by, anyone
          under the age of 18. By using the Service, you represent and warrant
          that you are 18 years of age or older. If you are not at least 18
          years of age, do not use, access, or register for the Service.
          Provider reserves the right to terminate your membership in the event
          that Provider becomes aware you are under 18.
        </p>
        <h6>4. User Accounts</h6>
        <p>
          To post information to and otherwise use the Service, you must first
          register by creating a User Account. User Account registration
          requires you to submit to Provider certain personal information, such
          as your name, address, mobile phone number, and other information. If
          you choose to set up your User Account to electronically pay for
          certain fee-based Services, you will also be required to provide a
          valid payment method. You grant Provider the right to provide any
          information you submit to Provider to third parties for purposes of
          facilitating the completion of any monetary transactions initiated by
          you or on your behalf. You understand that your continued use of the
          Services following any trial period may result in charges to you for
          the Services (“Charges”). Charges will be inclusive of applicable
          taxes where required by law. Charges are based on Services purchased
          and not actual usage and fees paid are non- refundable. Provider
          reserves the right to establish, remove and/or revise the Charges to
          you for the Services for all or part of the Services at any time in
          Provider’s sole discretion. Provider will use reasonable efforts to
          inform you of such Charges and You may elect to cancel the Services
          rather than pay the Charges. You understand that your continued use of
          the Services following notice from Provider may result in charges to
          you for the Services and that Provider may terminate or suspend the
          Services until you have paid the Charges.
        </p>
        <p>
          In addition to our use of third parties to process monetary
          transactions (e.g. credit card transactions), we also have
          arrangements with vendors who provide us with certain hosting and data
          storage services. Those companies are provided (either by us or
          directly by you) with your information as part of the service for
          which they are hired. These companies are authorized to use your
          information only as necessary to provide these services. We require
          these companies to maintain the confidentiality of the information
          they receive, and prohibit them from using the information for any
          other purpose.
        </p>
        <p>
          You are responsible for safeguarding the password that you use to
          access your User Account, and it is recommended that you choose a
          strong password, i.e., a password of sufficient length and complexity
          such that third parties will not readily guess your password. You
          should take measures to maintain and preserve the confidentiality of
          the username and password associated with your User Account, and you
          must notify Provider promptly of any unauthorized use or suspected
          breach of security of your User Account. Provider shall not be liable
          for any losses that may result from any unauthorized use of your User
          Account or failure to maintain appropriate confidentiality measures.
          You agree not to disclose your password to any third party and to take
          sole responsibility for any activities or actions under your User
          Account, whether or not you have authorized such activities or
          actions. Provider owns your User Account credentials and may revoke or
          change them at any time.
        </p>
        <h6>5. User Content</h6>
        <p>
          By using the Service, you may choose to submit information, data,
          passwords, usernames, PINs, other log-in information, as well as
          information regarding records, documents, and other materials and
          content relating thereto (collectively, the “User Content”). You
          expressly agree that you shall not post any User Content: (i) that
          infringes or misappropriates any third party’s copyright, patent,
          trademark, trade secret or other proprietary rights or rights of
          publicity or privacy; (ii) that violates any law, statute, ordinance
          or regulation (including, but not limited to, those governing export
          control, consumer protection, unfair competition, anti-discrimination
          or false advertising); (iii) that is or may reasonably be considered
          to be defamatory, libelous, hateful, racially or religiously biased or
          offensive, unlawfully threatening or unlawfully harassing to any
          individual, partnership or corporation; pornographic or obscene (iv)
          that contains individually identifiable health information subject to
          the HIPAA Privacy Rule; (v) that violates any other agreement you may
          have entered into with a third party; or (vi) that contains any
          computer viruses, worms or other potentially damaging computer
          programs or files.
        </p>
        <h6>6. Rights you Grant to Provider</h6>
        <p>
          By submitting User Content to Provider through the Service, you are
          licensing that User Content to Provider solely for the purpose of
          providing the Service. Included among that User Content may be your
          company name and logo, which you hereby authorize Provider to display
          on its website and customer list and in Provider’s marketing
          materials. Provider may use and store the User Content, but only to
          provide the Service to you. By submitting this User Content to
          Provider, you represent that you are entitled to submit it to Provider
          for use for this purpose, without any obligation by Provider to pay
          any fees or other limitations.
        </p>
        <h6>7. Access to Third Party Accounts</h6>
        <p>
          If you choose to use or access third party websites and/or accounts
          through the Service, you will be directly connected to the website for
          the third party you have identified. By using the Service in this
          manner, you expressly authorize Provider to access your account
          information maintained by such third parties, on your behalf as your
          agent. Provider will submit information including usernames and
          passwords that you provide to log you into the third-party site. You
          hereby authorize and permit Provider to disclose, use and store
          information submitted by you to the Service (such as account passwords
          and user names) to accomplish the foregoing and to configure the
          Service so that it is compatible with the third-party sites to which
          you submit your information. For purposes of this Agreement and solely
          to provide the account information to you as part of the Service, you
          grant Provider a limited power of attorney, and appoint Provider as
          your attorney-in-fact and agent, to access third party sites, retrieve
          and use your information with the full power and authority to do and
          perform each thing necessary in connection with such activities, as
          you could do in person. YOU ACKNOWLEDGE AND AGREE THAT WHEN PROVIDER
          IS ACCESSING AND RETRIEVING ACCOUNT INFORMATION FROM THIRD PARTY
          SITES, PROVIDER IS ACTING AS YOUR AGENT, AND NOT AS THE AGENT OF OR ON
          BEHALF OF THE THIRD PARTY. You understand and agree that the Service
          is not sponsored or endorsed by any third parties accessible through
          the Service.
        </p>
        <h6>8. Intellectual Property Rights</h6>
        <p>
          Unless otherwise noted, all text, images, graphics, photographs, video
          clips, designs, icons, sounds, information, data, and other materials
          appearing on the Service which are not User Content (the “Provider
          Content”) and all methods, methodologies, procedures, processes,
          know-how, software, algorithms, techniques, and other technology (the
          “Technology”) displayed, used, or incorporated on the Service by
          Provider are copyrights, trademarks, service marks, trade secrets, or
          other intellectual property or proprietary content owned or licensed
          by Provider. You may use the available Provider Content and Technology
          only for your own personal use and internal business purposes, but you
          may not reverse-engineer or decompile any of the Technology. You may
          print a copy of available Provider Content solely for such purposes,
          but you may not remove any copyright, trademark or other notice
          displayed on the corresponding webpage or print-out. You may not use
          the available Provider Content and Technology on behalf of any third
          party or as part of a managed service. You may not distribute,
          publish, transmit, modify, create derivative works from, or in any way
          exploit, any of the available Provider Content and Technology, in
          whole or in part, for any purpose without the express written
          permission of Provider or the respective owner. Nothing in this
          Agreement shall be construed as granting any permission (except as set
          forth in this paragraph), right, or license in any of the Provider
          Content or Technology. All intellectual property rights are fully
          reserved by Provider and any third-party owners of those rights.
        </p>
        <h6>9. Links to and from Other Websites</h6>
        <p>
          Portions of the Service may include links to third-party websites. In
          addition, you may have entered the Service via links on other
          third-party websites. Such links are provided or permitted to exist as
          a convenience measure, and Provider is not responsible for the
          information, advertising, products, services, content, or other
          material of any third-party website, regardless of whether such
          third-party website links to the Service or is accessible by a link
          from the Service. The inclusion and use of links does not imply
          sponsorship or endorsement by Provider of any third-party website.
          Provider may provide experiences on social media platforms such as
          Facebook® and Twitter® that enable online sharing and collaboration
          among users who have registered to use them. Any content you access or
          post through such platforms, e.g., pictures, information, opinions, or
          any personal information that you make available to other participants
          on these social platforms, is subject to the terms of use and privacy
          policies of those platforms. Please refer to those social media
          platforms to better understand your rights and obligations with regard
          to such content.
        </p>
        <h6>10. Use of “Cookies” and Similar Tools</h6>
        <p>
          You understand and agree that Provider may store information on your
          computer in the form of a “cookie” or similar tool for purposes of
          improving the functionality of the Service.
        </p>
        <h6>11. Disclaimer of Warranties</h6>
        <p>
          Provider does not warrant that the Service will be available. Your
          access and use of the Service may be interrupted from time to time for
          any of several reasons, including, without limitation, the malfunction
          of equipment, periodic updating, maintenance or repair of the Service
          or other actions that Provider, in its sole discretion, may elect to
          take. Provider does not warrant that User Content, Provider Content,
          or Technology, regardless of its source, is accurate, complete,
          reliable or current. The Service is provided for informational
          purposes only and does not constitute an endorsement by Provider of
          any product, service or merchant. You should not rely on such
          information in situations where its inaccuracy could cause you to
          suffer any loss. ALL PRODUCTS, SERVICES, INFORMATION, DATA, TEXT, USER
          CONTENT, PROVIDER CONTENT, TECHNOLOGY, AND RELATED GRAPHICS CONTAINED
          WITHIN OR AVAILABLE THROUGH THE SERVICE ARE PROVIDED TO YOU ON AN “AS
          IS” AND “AS AVAILABLE” BASIS. PROVIDER MAKES NO REPRESENTATIONS OR
          WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, AS TO THE OPERATION
          OF THE SERVICE. WITHOUT LIMITING THE FOREGOING, PROVIDER DOES NOT
          WARRANT OR REPRESENT THAT THE SERVICE WILL OPERATE ERROR-FREE OR
          UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, OR THAT THE SERVICE AND
          ITS SERVERS WILL BE FREE OF VIRUSES AND OTHER HARMFUL COMPONENTS. TO
          THE FULLEST EXTENT PERMISSIBLE PURSUANT TO APPLICABLE LAW, PROVIDER
          DISCLAIMS ALL REPRESENTATIONS AND WARRANTIES OF ANY KIND, EITHER
          EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
          WARRANTIES OF (I) MERCHANTABILITY OR SATISFACTORY QUALITY, (II)
          FITNESS FOR A PARTICULAR PURPOSE, (III) TITLE, AND (IV)
          NON-INFRINGEMENT OF THE RIGHTS OF THIRD PARTIES. PROVIDER FURTHER
          MAKES NO WARRANTIES OR REPRESENTATIONS OF ANY KIND, EXPRESS, STATUTORY
          OR IMPLIED AS TO: (I) THE AVAILABILITY OF TELECOMMUNICATION SERVICES
          AND ACCESS TO THE SERVICE AT ANY TIME OR FROM ANY LOCATION; (II) ANY
          LOSS, DAMAGE, OR OTHER SECURITY INTRUSION OF YOUR TELECOMMUNICATION
          SERVICES; AND (III) ANY DISCLOSURE OF INFORMATION TO THIRD PARTIES OR
          FAILURE TO TRANSMIT ANY DATA, COMMUNICATIONS OR SETTINGS CONNECTED
          WITH THE SERVICE.
        </p>

        <h6>12. Limitations on Liability</h6>
        <p>
          In no event shall Provider, its agents, licensors, or service
          providers, or any other person or entity involved in creating,
          promoting, maintaining, hosting, or otherwise making available any
          User Content, Provider Content, Technology, or other aspect of the
          Service, be liable to you or any other person or entity for any
          direct, indirect, incidental, special, consequential, punitive, or
          other such damages, including but not limited to any damages
          associated with: (i) loss of goodwill, profits, business interruption,
          or data, or other such losses; (ii) your inability to use the Service,
          any unauthorized use of the Service, or any function of the Service or
          failure of the Service to function; (iii) the provision of or failure
          to provide any service though the Service; (iv) errors or inaccuracies
          in the User Content, Provider Content, Technology, or any advertising
          or other information, software, products, services, and related
          graphics used, viewed, or obtained through the Service; or (v) any
          property loss including damage to your computer or computer system
          caused by viruses or other harmful components encountered during or on
          account of access to or use of this Service or any third-party website
          linked to this Service. These limitations of liability shall apply
          regardless of the form of action, whether based in contract,
          negligence, strict liability, other tort, or otherwise, and even if
          Provider has been advised of the possibility of any particular
          damages. To the extent you allege or assert any damages associated
          with the Service which are not excluded by the foregoing, then
          Provider’s liability (and that of its agents, licensors, or service
          providers) for such damages shall not exceed one hundred dollars
          ($100.00 USD).
        </p>
        <h6>13. Indemnification</h6>
        <p>
          You agree to indemnify, defend, and hold harmless Provider, its
          agents, licensors, and service providers, and their respective past
          and present officers, directors, employees, and representatives, from
          and against any and all claims, actions, demands, liabilities, costs,
          and expenses, including, without limitation, reasonable attorneys’
          fees, resulting from your breach of any provision of this Agreement,
          including any warranty you provide herein, or otherwise resulting in
          any way from your use of the Service.
        </p>
        <h6>14. Copyright Complaints</h6>
        <p>
          If you have a good faith belief that your work has been copied in a
          way that constitutes copyright infringement, or that your intellectual
          property rights have been otherwise violated, please provide
          Provider’s designated agent with the following information:
        </p>
        <ul>
          <li>
            a physical or electronic signature of the person authorized to act
            on behalf of the owner of the copyright or other intellectual
            property interest that is allegedly infringed;
          </li>
          <li>
            identification or description of the copyrighted work or other
            intellectual property that you claim has been infringed. If you are
            asserting infringement of an intellectual property right other than
            copyright, please specify the intellectual property right at issue
            (for example, trademark or patent);
          </li>
        </ul>
        <ul>
          <li>
            identification or description of where the material that you claim
            is infringing is located on the Service, with enough detail that we
            may find it on the Service;
          </li>
          <li>
            your address, telephone number, and email address; a statement by
            you that you have a good faith belief that the use of the material
            complained of is not authorized by the copyright or intellectual
            property owner, its agent, or the law; and
          </li>
          <li>
            a statement by you, made under penalty of perjury, that the
            information in your notice is accurate and that you are the
            copyright or intellectual property owner or authorized to act on the
            copyright or intellectual property owner’s behalf.
            <p>
              {" "}
              • Provider’s agent designated to receive claims of copyright or
              other intellectual property infringement may be contacted by email
              at the following address:{" "}
              <a href="mailto:webmaster@superiorloanservicing.com">
                webmaster@superiorloanservicing.com
              </a>
              . Provider has adopted and implemented a policy that provides for
              the termination in appropriate circumstances of the accounts of
              users who repeatedly infringe copyrights or other intellectual
              property rights of Provider and/or others. For more details on the
              information required for valid DMCA notification, see 17 U.S.C.
              512(c)(3). You should be aware that, under the DMCA, claimants who
              make misrepresentations concerning copyright infringement may be
              liable for damages incurred as a result of the removal or blocking
              of the material, court costs, and attorney’s fees.
            </p>
          </li>
        </ul>
        <h6>15. Governing Law; Disputes; Enforceability</h6>
        <p>
          These Terms and the relationship between you and Provider will be
          governed by the laws of the State of California, USA (or applicable
          federal law), without regard to its conflict of law provisions. You
          agree to submit to the personal jurisdiction of the state and federal
          courts located in California, and waive any objections thereto. You
          further agree that any dispute arising from or related to your use of
          the Service must be brought exclusively in the state or federal courts
          located in Los Angeles County, California, unless a California
          mandatory venue statute applies to the dispute, in which case the
          California county of mandatory venue shall be the exclusive
          jurisdiction for such dispute. You expressly consent to the personal
          jurisdiction of such courts and waive all objections hereto. If any
          provision of this Agreement shall be determined to be void or
          unenforceable in whole or in part, the remaining provisions of this
          Agreement shall not be affected thereby and shall remain in force and
          effect.
        </p>
        <h6>16. Assignability</h6>
        <p>
          Provider may assign this Agreement and its rights and obligations
          hereunder to an affiliated company or, in the event of a merger or
          acquisition of Provider or the sale of substantially all of Provider’s
          assets related to the services being provided to you, to the surviving
          or successor entity with reasonable notice to you. You may not assign
          this Agreement or the rights and obligations hereunder without the
          prior written consent of Provider.
        </p>
        <h6>17. Term Termination</h6>
        <p>
          The term of this Agreement shall commence upon your first use of the
          Service, and shall continue (i) as long as you or any persons given
          access by you retain access rights to the Service, or (ii) until
          Provider ceases to operate the Service or closes your User Account.
          Provider shall not have any ongoing obligation to provide the Service;
          thus, Provider may cease to operate the Service at any time and for
          any reason. Without limiting the foregoing, Provider may cease to
          provide your User Account in the event of: (i) any dispute or
          termination of Provider’s relationship with you; (ii) any dispute
          concerning ownership or control of your User Account; or (iii) use of
          your User Account in a manner that Provider, in its sole discretion,
          considers improper or unacceptable. Provider reserves the right to
          limit the period of time during which Provider may make any User
          Content pertaining to you available on the Service. The Service should
          not be viewed as your backup, archival or storage service with respect
          to any User Content.
        </p>
        <h6>18. Privacy Policy</h6>
        <p>
          Any data that you provide to Provider using this Service is subject to
          the Privacy Policy that is posted on the Service and in effect at the
          time such data is provided. Provider may update its Privacy Policy
          from time to time, so you should be sure to review the Privacy Policy
          posted on the Service prior to providing any information to Provider
          using the Service. This Agreement and Provider’s Privacy Policy (which
          is incorporated herein by reference) constitute the entire Agreement
          and supersede any other agreements or understandings (oral or written)
          between you and Provider with respect to their subject matters.
        </p>
        <h6>19. Same Day Payment</h6>
        <p>
          <strong>Information for Consumers: </strong>Starting 6/15/2022,
          Superior Loan Servicing is launching its same day payment offering.
          This is called “Same Day Payment”. Currently, most ACH payments are
          settled on the next business day after submitting them. With Same Day
          Payment, a written check could be deducted from your account the same
          day you write it. Previously, it might have taken 2-3 days to post to
          your account.
        </p>
        <p>
          Same Day Payment can benefit our clients by allowing them to expedite
          billing payments to make on-time bill payments on due dates. The
          Automated Clearing House, or ACH, is essentially the way banks, credit
          unions and businesses move money between accounts. Same Day Payment is
          an improvement to the ACH network. It allows debit transactions to be
          processed several times daily, resulting in same-day processing and
          settlement of ACH transactions.
        </p>
        <p>
          <strong>Fees:</strong> There is a $30 fee for this service.
        </p>
        <p>
          <strong>Cut Off Time:</strong> Cut off time when the payment can flow
          through our system is M – F 5:00pm pst, payments posted after this
          time will be made next business day.
        </p>
        <p>
          <strong>Payment Failure: </strong>Non-Sufficient Funds – payment
          failure due to non-sufficient funds (NSF) will cause Customer to incur
          an NSF fee of $45.00 per occurrence.
        </p>
        <p>
          <strong>Notifications: </strong>Client will receive an email stating
          that a same day payment transaction was submitted. If you don’t
          receive this email then you need to call our customer support number
          to ensure that you can submit
        </p>
        <p>
          <strong>Hold Harmless: </strong>Customer hereby acknowledges and
          accepts the provisions and charges delineated above and agrees to hold
          Superior Loan Servicing harmless from and against any and all claims,
          demands, and causes of action of any kind or character, including the
          cost of defense thereof, arising from Customer's utilization of the
          same day payment request option via the online portal. Additionally,
          Customer holds Superior Loan Servicing harmless for any additional
          charges incurred by Customer, both internally by way of the online
          portal and externally as it relates to any third-party institutions,
          associated with a failed payment due to non-sufficient funds."
        </p>
        <p>
          <strong>
            Who do I contact if I have questions regarding Same Day Payment?
          </strong>
          &nbsp; Please contact our customer service team at 818-483-0027 or
          email us at <a href="mailto:lss@slsbox.com">lss@slsbox.com</a>
        </p>
        <h6>20. Paperless Statements</h6>

        <ul>
          <li>
            By accepting the Terms of Use,&nbsp;
            <strong>
              you are agreeing to receive all your statements electronically.
            </strong>
            &nbsp;You may cancel paperless statements at any time and request to
            receive a printed statement by going to the “Profile” section of the
            online portal and check the box for “Printed Statements”. You may
            also contact Customer Service at 818-483-0027 or email us at&nbsp;
            <a href="mailto:lss@slsbox.com">lss@slsbox.com</a>&nbsp;to un-enroll
            from paperless statements. To access your electronic statements, you
            will need to register for the online portal. There is no fee charged
            for this service.
            <p>
              {" "}
              You will be able to access your electronic statement by logging
              into to the online portal. If you do not immediately report to
              Superior Loan Servicing any error, irregularity, discrepancy, or
              unauthorized fees, you shall be deemed conclusively to have
              accepted all matters contained in the electronic statement to be
              true, accurate, and correct in all respects.
            </p>
          </li>
          <li>
            In order to ensure that we are able to provide you with important
            notice and statements, you agree to notify immediately of any change
            in your email address. You also agree that all change in terms
            notifications, tax forms, notices, legal, and other notices that we
            are legally required may be provided only through this notification.
          </li>
          <li>
            If you have more than one loan being serviced by us, your preference
            will be applied to all the loans associated with your email address.
          </li>
          <li>
            You agree that we shall not be liable if you are unable to gain
            access to the online portal from time to time. You understand that
            some or all of the electronic statements and/or online services may
            not be available at certain times due to maintenance and/or
            computer, communication, electrical or network failure or any other
            causes beyond our control.
          </li>
          <li>
            You agree to protect the confidentiality of your User ID and
            password. You understand, that the User ID and password by itself or
            together with other account information may allow unauthorized
            access to your account.
          </li>
        </ul>
      </div>
    </div>
  );
}

export default TermsOfService;
